import { render, staticRenderFns } from "./EntityModal.vue?vue&type=template&id=5b72cf1c&lang=pug"
import script from "./EntityModal.vue?vue&type=script&lang=js"
export * from "./EntityModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports